// extracted by mini-css-extract-plugin
export default {"Button":"IconButton_Button__K6kUV","Icon":"IconButton_Icon__BUZ4x"};